import React, { useEffect } from "react";
import { Table, Skeleton, Tooltip, Row, Pagination, Icon, Button } from "antd";
import EditIcon from "../../Icons/EditIcon";
import DeleteIcon from "../../Icons/DeleteIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  selectRecipientsSearch,
  setPagination,
} from "../../../redux/slices/recipientsSearchSlice";

const checkDataValue = (value) => {
  if (!value) {
    return "N/D";
  }
  return value;
};

export default function RecipientsTable({ recipientsDetails, tableActions }) {
  const {
    toggleGenericModal,
    toggleDecisionConfirmationModal,
    getPagedRecipients,
  } = tableActions;

  const dispatch = useDispatch();
  const searchParameters = useSelector(selectRecipientsSearch);

  const { data } = recipientsDetails;
  const isLoading =
    recipientsDetails?.isLoading || recipientsDetails?.status === "loading";
  const showTable = recipientsDetails?.searchWasMade === true;

  const columns = [
    {
      title: "Nombre destinatario / Empresa",
      dataIndex: "name",
      sorter: (a, b) => {
        return a.name.localeCompare(b.name);
      },
      width: "auto",
      align: "center",
    },
    {
      title: "Alias",
      dataIndex: "alias",
      sorter: (a, b) => {
        return a.alias.localeCompare(b.alias);
      },
      width: 90,
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Dirección",
      dataIndex: "address",
      width: "auto",
      align: "center",
    },
    {
      title: "CP (Localidad)",
      dataIndex: "postalCode",
      width: "auto",
      align: "center",
      render: (value, row) => (
        <div>
          <span>{row?.postalCode}</span>
          <br />
          <span>({row?.city})</span>
        </div>
      ),
    },
    {
      title: "País",
      dataIndex: "country",
      width: 70,
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "auto",
      align: "center",
    },
    {
      title: "Teléfono móvil",
      dataIndex: "mobilePhone",
      width: "auto",
      align: "center",
    },
    {
      title: "NIF/NIE/ Otros",
      dataIndex: "documentId",
      width: "auto",
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Persona de contacto",
      dataIndex: "contactPerson",
      width: "auto",
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Teléfono de contacto",
      dataIndex: "contactPhone",
      width: "auto",
      align: "center",
    },
    {
      title: "Acciones",
      width: 90,
      align: "center",
      render: (value, row) => (
        <div className="actions-container">
          <span>
            <a
              style={{ marginRight: 8 }}
              onClick={(e) => toggleGenericModal("recipientEditForm", row)}
            >
              <EditIcon />
            </a>
          </span>
          <span>
            <a onClick={(e) => toggleDecisionConfirmationModal(row)}>
              <DeleteIcon />
            </a>
          </span>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    dispatch(setPagination({ page, size: pageSize }));
    getPagedRecipients(
      page,
      pageSize,
      searchParameters.participantName,
      searchParameters.participantAlias,
      true,
    );
  };

  const handlePageSizeChange = (page, size) => {
    dispatch(setPagination({ page, size }));
    getPagedRecipients(
      page,
      size,
      searchParameters.participantName,
      searchParameters.participantAlias,
      true,
    );
  };

  if (isLoading) {
    return (
      <div className="RecipientsTables">
        <Row>
          <div style={{ margin: "16px 0" }}>
            <h2>Resultados</h2>
          </div>
          <Skeleton />
        </Row>
      </div>
    );
  }

  const paginatorConfig = {
    pageSize: searchParameters.size,
    current: searchParameters.page,
    total: recipientsDetails.total,
    onChange: handlePageChange,
    showSizeChanger: true,
    showQuickJumper: true,
    onShowSizeChange: handlePageSizeChange,
    showTotal: (total) => `${total} resultados`,
    pageSizeOptions: ["10", "20", "40", "80"],
  };

  if (showTable && data?.length > 0) {
    return (
      <div className="RecipientsTables">
        <Row>
          <div style={{ margin: "16px 0" }}>
            <h2>Resultados</h2>
          </div>
          <div className="tracks-table-scroll">
            <Table
              columns={columns}
              dataSource={data}
              bordered
              rowKey={(row) => row?.participantId}
              pagination={false}
              loading={recipientsDetails?.isPaginating}
            />
          </div>
        </Row>
        <Row
          type="flex"
          justify="end"
          style={{ marginTop: 16, background: "none", padding: 0 }}
        >
          <Pagination {...paginatorConfig} />
        </Row>
      </div>
    );
  }

  if (showTable && data?.length == 0) {
    return (
      <div className="RecipientsTables">
        <div style={{ margin: "16px 0" }}>
          <h2>Resultados</h2>
        </div>
        <Row>
          <p>Aún no hay ningún destinatario almacenado.</p>
        </Row>
      </div>
    );
  }
  return null;
}
